import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import Image = Phaser.GameObjects.Image;
import CreaturePanel from "@/scenes.ui/creature-panel";
import Arrow from "@/scenes.ui/arrow";
import SpriteUtils from "@/utils/sprite-utils";
import Tween = Phaser.Tweens.Tween;
import TweenChain = Phaser.Tweens.TweenChain;

export default class BattleLesson extends Phaser.GameObjects.Container {

    private readonly HAND_WIDTH: number = 199;
    private readonly HAND_HEIGHT: number = 206;
    private readonly HAND_DEPTH: number = 100;
    private readonly HAND_ORIGIN_X: number = 0.3;
    private readonly HAND_ORIGIN_Y: number = 0.25;
    private readonly RUN_LESSON_DELAY: number = 1300;
    private readonly HAND_MOVING_DELAY: number = 500;
    private readonly ARROW_ORIGIN_X: number = 0.5;
    private readonly ARROW_ORIGIN_Y: number = 1;
    private readonly ARROW_ROTATION_OFFSET: number = 1.55;
    private readonly ARROW_HEIGHT_OFFSET: number = 35;
    private readonly ARROW_DISPLAY_WIDTH: number = 128;

    private startCreature!: CreaturePanel;
    private targetCreature!: CreaturePanel;

    private readonly handImage!: Image;
    private readonly handImageShadow!: Image;
    private readonly arrowImage!: Arrow;

    private lessonTween!: TweenChain;

    constructor(scene: Scene, x: number, y: number, startCreature: CreaturePanel, targetCreature: CreaturePanel) {
        super(scene)
        this.scene = scene;

        this.y = y;
        this.x = x;

        this.startCreature = startCreature;
        this.targetCreature = targetCreature;

        this.setVisible(false);
        this.setSize(this.HAND_WIDTH, this.HAND_HEIGHT);
        this.setDepth(this.HAND_DEPTH);

        this.handImage = SpriteUtils.addImage(this.scene, 0,75, Keys.IMG_LESSON_HAND)
            .setOrigin(this.HAND_ORIGIN_X, this.HAND_ORIGIN_Y);
        SpriteUtils.setDispSize(this.handImage, this.HAND_WIDTH, this.HAND_HEIGHT);

        this.handImageShadow = SpriteUtils.addImage(this.scene, 0,75, Keys.IMG_LESSON_HAND_SHADOW)
            .setOrigin(this.HAND_ORIGIN_X, this.HAND_ORIGIN_Y);
        SpriteUtils.setDispSize(this.handImageShadow, this.HAND_WIDTH, this.HAND_HEIGHT);

        this.arrowImage = new Arrow(this.scene)
            .setOrigin(this.ARROW_ORIGIN_X, this.ARROW_ORIGIN_Y)
            .setVisible(false);
        SpriteUtils.setDispSize(this.arrowImage, this.ARROW_DISPLAY_WIDTH, 0);

        this.add([this.arrowImage, this.handImageShadow, this.handImage]);
    }

    public showLesson() {
        this.scene.time.delayedCall(this.RUN_LESSON_DELAY, () =>{
            this.setVisible(true);
            this.showHandAnimations()
        });
    }

    private showHandAnimations() {

        let self = this;

        let startX = self.startCreature.x - this.x;
        let startY = self.startCreature.y - this.y;

        let endX = self.targetCreature.x - this.x;
        let endY = self.targetCreature.y - this.y;

        let offsetX = 15;

        let pressImitationOffsetX = 1.5;
        let pressImitationOffsetY = 7;

        let duration = 700;
        let ease = 'Quad.easeOut';

        if (this.scene) {

            this.lessonTween = this.scene.tweens.chain({
                targets: [this.handImage, this.handImageShadow],
                duration: duration,
                delay: this.HAND_MOVING_DELAY,
                loop: 30,

                tweens: [{
                    // Движение к атакующей карте
                    x: {value: startX + offsetX},
                    y: {value: startY},
                    duration: 600
                },
                {
                    // Имитация нажатия на карту
                    duration: 100,
                    angle: -2,
                    x: {value: startX - pressImitationOffsetX + offsetX},
                    y: {value: startY + pressImitationOffsetY},
                    // Увеличиваем размер и подсвечиваем
                    onComplete() {
                        self.startCreature.turnOnAttackerLook();
                        self.arrowImage.setPosition(startX, startY);
                        self.arrowImage.setVisible(true);
                    }
                },
                {
                    // Движение к карте защиты
                    x: {value: endX + offsetX},
                    y: {value: endY},

                    onUpdate() {

                        self.arrowImage.calculateRotationAngle(self.arrowImage.x,  self.arrowImage.y, self.handImage.x - offsetX, self.handImage.y);
                        self.arrowImage.calculateDisplayHeight(self.arrowImage.x,  self.arrowImage.y,
                            self.handImage.x, self.handImage.y, 1.01);

                        self.targetCreature.turnOnDefenderLook();
                    },
                    // Увеличиваем размер и подсвечиваем
                    onComplete() {
                        self.targetCreature.turnOnDefenderLook();
                    }
                },
                {
                    // Имитация отпуска карты
                    duration: 100,
                    angle: +3,
                    x: {value: endX + pressImitationOffsetX + offsetX},
                    y: {value: endY - pressImitationOffsetY},
                    // Дефолтим
                    onComplete() {

                        self.arrowImage.setZeroHeight();
                        self.arrowImage.setVisible(false);

                        self.startCreature.turnOnDefaultLook();
                        self.targetCreature.turnOnDefaultLook();
                    }
                }],
                onComplete() {
                    self.destroy();
                }
            })
        }
    }

    public destroyLesson() {
        this.startCreature.turnOnDefaultLook();
        this.targetCreature.turnOnDefaultLook();
        if (this.lessonTween) {
            this.lessonTween!.stop();
        }
        this.destroy();
    }
}
